// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"2b28972c","51":"db9758ad","217":"255f256e","325":"7beb9b2d","532":"41c808f2","662":"910a4a10","768":"7d7ee053","813":"c2591471","961":"8e409733"}[chunkId] + ".chunk.js";
};